import { render, staticRenderFns } from "./LPTemp3.vue?vue&type=template&id=4f4922f8&scoped=true&"
import script from "./LPTemp3.vue?vue&type=script&lang=js&"
export * from "./LPTemp3.vue?vue&type=script&lang=js&"
import style0 from "./LPTemp3.vue?vue&type=style&index=0&id=4f4922f8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4922f8",
  null
  
)

export default component.exports